import { appConstants } from "../../constants/appconstants";
import { postApiCall } from "../../utils/ApiMethods";
import { putApiCall } from "../../utils/ApiMethods";

const SaveTilesOrderAction = (requestObj) => {
    return async function (dispatch) {
        const data = await putApiCall(`${appConstants.BASE_URL}/user/save-tiles-order`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_SAVE_TILES_ORDER_ACTION' }, {tilesOrderDetails: data});
        dispatch(resData);
    }
}

const resetToDefaultTilesOrderAction = (requestObj) => {
    return async function (dispatch) {
        const data = await putApiCall(`${appConstants.BASE_URL}/user/reset-tiles-order`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION' }, {tilesOrderDetails: data});
        dispatch(resData);
    }
}

export { SaveTilesOrderAction, resetToDefaultTilesOrderAction }